import React from 'react';
import _sortBy from 'lodash/sortBy';
import { withRouter } from 'react-router-dom';
import * as API from 'api';

import { withStyles } from '@material-ui/core/styles';

import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableRow from '@material-ui/core/TableRow';

import Row from './Row';
import { useQuery } from 'react-query';

const Users = API.Users();

const styles = () => ({
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
});

const createRowData = row => {
  return {
    id: row.user_user_id,
    email: row?.email || '—',
    name: row?.name,
    role: row?.role,
    kyc_verified_at: row?.kyc_verified_at,
    accepted_terms_at: row?.accepted_terms_at,
  };
};

const TableGroupUsers = ({ group, ownerEmail, users, refetchUsers }) => {
  const meQuery = useQuery(['me'], () => Users.getMe());
  const dataMe = meQuery?.data;

  return (
    <MuiTable aria-label="collapsible table">
      <MuiTableHead>
        <MuiTableRow>
          <MuiTableCell>id</MuiTableCell>
          <MuiTableCell>Email Address</MuiTableCell>
          <MuiTableCell>Name</MuiTableCell>
          <MuiTableCell>Role</MuiTableCell>
          <MuiTableCell>Accepted Terms</MuiTableCell>
          <MuiTableCell>KYC Verified</MuiTableCell>
          <MuiTableCell align="right">Actions</MuiTableCell>
        </MuiTableRow>
      </MuiTableHead>
      <MuiTableBody>
        {dataMe &&
          _sortBy(users, ['name']).map((row, i) => (
            <Row
              key={i}
              row={createRowData(row)}
              group={group}
              isOwner={ownerEmail && row?.email === ownerEmail}
              myUserId={dataMe?.auth0RealUserId}
              refetchUsers={refetchUsers}
            />
          ))}
      </MuiTableBody>
    </MuiTable>
  );
};

export default withStyles(styles)(withRouter(TableGroupUsers));
